// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const deferDispatch = require('client-v2/common/state/dispatch')
// Container imports
const profileUserActions = require('../profile-user/actions')
const UserProfileContentHeader = require('./component-dumb')

function mapStateToProps(state) {
  const {
    profileUser,
    profileUserStats,
    user
  } = state
  return {
    // Flags
    isLoggedIn: user.loggedIn,
    isSelfProfile: user.id === profileUser.id,
    // Values
    profileUser,
    profileUserStats
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction, dispatchAuthRequiredAction } = deferDispatch(dispatch)
  return {
    onFollowClick: dispatchAuthRequiredAction(
      profileUserActions.toggleFollowing,
      authModalActions.showSignup
    ),
    onFollowersClick: dispatchAction(profileUserActions.navigateToUserProfileFollowers),
    onFollowingClick: dispatchAction(profileUserActions.navigateToUserProfileFollowing),
    onMoreClick: dispatchAction(profileUserActions.showUserActionsModal),
    onShareClick: dispatchAction(profileUserActions.showUserShareModal)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    UserProfileContentHeader
  )
)
